import { call, takeLatest } from "redux-saga/effects";
import axiosInstance from "../axiosInstance";
import ENV from "../config/env";
import {
  CANDIDATE_LIST_REQUEST,
  CANDIDATE_PERSONAL_INFO_REQUEST,
  CANDIDATE_ADDRESS_INFO_REQUEST,
  CANDIDATE_KEY_SKILLS_REQUEST,
  CANDIDATE_CERTIFICATIONS_REQUEST,
  CANDIDATE_EDUCATION_REQUEST,
  CANDIDATE_WORK_EXPERIENCE_REQUEST,
  CANDIDATE_ACCOMPLISHMENTS_REQUEST,
  CANDIDATE_DOC_INFO_REQUEST,
  CANDIDATE_JOB_PREFERENCES_REQUEST,
  DESIGNATION_DROPDOWN_REQUEST,
  DEGREE_TYPE_DROPDOWN_REQUEST,
} from "./candidateManagement.types";

function getErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error.message ||
    "Something went wrong"
  );
}

function* candidateListSaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.CANDIDATE_SERVICE_URL}/listing/CandidateDetails`,
      payload
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* candidatePersonalInfoSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.CANDIDATE_SERVICE_URL}/get/CandidatePersonalInfo?id=${id}`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* candidateAddressInfoSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.CANDIDATE_SERVICE_URL}/get/CandidateAddressDetails?id=${id}`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* candidateKeySkillsSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.CANDIDATE_SERVICE_URL}/get/CandidateKeySkills?id=${id}`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* candidateCertificationsSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.CANDIDATE_SERVICE_URL}/get/CandidateCertificationAndLicensing?candidateId=${id}`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* candidateEducationSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.CANDIDATE_SERVICE_URL}/get/CandidateEducationDetails?candidateId=${id}`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* candidateWorkExperienceSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.CANDIDATE_SERVICE_URL}/get/CandidateWorkExperience?candidateId=${id}`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* candidateAccomplishmentsSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.CANDIDATE_SERVICE_URL}/get/CandidateAccomplishments?id=${id}`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* candidateDocInfoSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.CANDIDATE_SERVICE_URL}/get/CandidateDocInfo?id=${id}`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* candidateJobPreferencesSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.CANDIDATE_SERVICE_URL}/get/CandidateJobPreferences?candidateId=${id}`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* designationDropdownSaga(action) {
  const { callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.COMMAN_SERVICES_URL}/get/DesignationDropdown`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* degreeTypeDropdownSaga(action) {
  const { callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.COMMAN_SERVICES_URL}/get/DegreeTypeDropdown`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

export function* candidateManagementWatcherSaga() {
  yield takeLatest(CANDIDATE_LIST_REQUEST, candidateListSaga);
  yield takeLatest(CANDIDATE_PERSONAL_INFO_REQUEST, candidatePersonalInfoSaga);
  yield takeLatest(CANDIDATE_ADDRESS_INFO_REQUEST, candidateAddressInfoSaga);
  yield takeLatest(CANDIDATE_KEY_SKILLS_REQUEST, candidateKeySkillsSaga);
  yield takeLatest(CANDIDATE_CERTIFICATIONS_REQUEST, candidateCertificationsSaga);
  yield takeLatest(CANDIDATE_EDUCATION_REQUEST, candidateEducationSaga);
  yield takeLatest(CANDIDATE_WORK_EXPERIENCE_REQUEST, candidateWorkExperienceSaga);
  yield takeLatest(CANDIDATE_ACCOMPLISHMENTS_REQUEST, candidateAccomplishmentsSaga);
  yield takeLatest(CANDIDATE_DOC_INFO_REQUEST, candidateDocInfoSaga);
  yield takeLatest(CANDIDATE_JOB_PREFERENCES_REQUEST, candidateJobPreferencesSaga);
  yield takeLatest(DESIGNATION_DROPDOWN_REQUEST, designationDropdownSaga);
  yield takeLatest(DEGREE_TYPE_DROPDOWN_REQUEST, degreeTypeDropdownSaga);
}
